export const vanWindNaarWatt = {
    quote: [
        'For the project Van Wind naar Watt we were looking for a partner who could develop a website with information for teachers and a place where children could view videos and images. The Pack came up with new ideas and was open to contribute ideas or to improve processes. Clear agreements were made about when what should be delivered. The Pack was the partner we needed.',
    ],
    from: 'Karien Reichman',
    role: 'Projectmanager',
    company: 'BKK/Doorviendschap Sterker',
};
